export default __webpack_public_path__ + "static/media/12.e13597c5.png";